import { useTranslation } from 'react-i18next';
import PageHeader from '@/components/ui/PageHeader';
import Card from '@/components/ui/Card';
import ThemeSwitcher from '@/components/ui/ThemeSwitcher';
import LanguageSwitcher from '@/components/ui/LanguageSwitcher';
import { useTheme } from '@/contexts/ThemeContext';

export default function Appearance() {
  const { t } = useTranslation();
  const { currentTheme, mode } = useTheme();

  return (
    <>
      <PageHeader kicker="Movez" title={t('common.appearance')} />

      <Card>
        <ThemeSwitcher />
      </Card>

      <Card style={{ marginTop: 'var(--space-4)' }}>
        <div className="kicker" style={{ marginBottom: 12 }}>
          {t('common.language')}
        </div>
        <LanguageSwitcher />
      </Card>

      <Card style={{ marginTop: 'var(--space-4)' }}>
        <div className="kicker" style={{ marginBottom: 12 }}>
          Preview · {currentTheme?.name} {mode}
        </div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {['bg', 'surf', 'surf2', 'volt', 'volt2', 'frost', 'hi', 'mid'].map((token) => (
            <div key={token} style={{ textAlign: 'center' }}>
              <div
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: 'var(--radius-md)',
                  border: '1px solid var(--line)',
                  background: `var(--${token})`,
                }}
              />
              <div className="kicker" style={{ marginTop: 6, fontSize: 9 }}>
                {token}
              </div>
            </div>
          ))}
        </div>
      </Card>
    </>
  );
}
